import React from "react";
import { Box } from "@mui/material";

const BannerSection = ({ bannerImage, IMAGE_BASE_URL }) => {
  console.log("🖼️ BannerSection - bannerImage:", bannerImage);

  if (!bannerImage) {
    console.log("⚠️ لا توجد صورة بانر");
    return null;
  }

  const fullImageUrl = `${IMAGE_BASE_URL}${bannerImage}`;
  console.log("🔗 رابط البانر الكامل:", fullImageUrl);

  return (
    <Box
      sx={{
        width: "100%",
        position: "relative",
        bgcolor: "#f5f5f5",
        overflow: "hidden",
      }}
    >
      <Box
        component="img"
        src={fullImageUrl}
        alt="Banner"
        onLoad={() => console.log("✅ تم تحميل صورة البانر بنجاح")}
        onError={(e) => {
          console.error("❌ فشل تحميل صورة البانر:", fullImageUrl);
          e.target.style.display = "none";
        }}
        sx={{
          width: "100%",
          height: "auto",
          display: "block",
          maxHeight: { xs: 200, sm: 300, md: 400 },
          objectFit: "contain",
          objectPosition: "center",
          bgcolor: "#f5f5f5",
        }}
      />
    </Box>
  );
};

export default BannerSection;
